import React, { useState } from "react";
import { Route, Routes, Outlet, Navigate } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthProvider";
import { ItemProvider } from "./contexts/ItemContext";
import { FavsProvider } from "./contexts/FavsProvider";

import Home from "./pages/Home/Home";
import Cart from "./pages/Cart/Cart";
import Profile from "./pages/Profile/Profile";
import BlockPage from "./pages/BlockPage";
import Game from "./components/Games/Games";
import BottomMenu from "./components/BottomMenu/BottomMenu";
import Load from "./components/Loading";

import "./App.scss";

const Layout = () => {
	return (
		<div className="app">
			<Outlet />
			<BottomMenu />
		</div>
	);
};

const Page = ({ children }) => <div className="main">{children}</div>;

function App() {
	const [globalLoading, setGlobalLoading] = useState(true);

	// Callback from Home to signal that global loading can stop
	const handleHomeLoadingComplete = () => {
		setGlobalLoading(false);
	};

	// For demonstration: If the user is blocked, redirect all routes to BlockPage
	const isBlocked = false; // Update logic as needed

	return (
		<AuthProvider>
			<FavsProvider>
				<ItemProvider>
					{isBlocked ? (
						// If blocked, immediately navigate to /block
						<Routes>
							<Route
								path="*"
								element={
									<Page>
										<BlockPage />
									</Page>
								}
							/>
						</Routes>
					) : (
						<Routes>
							<Route path="/" element={<Layout />}>
								<Route
									path="home"
									element={
										<Page>
											<Home onLoadingComplete={handleHomeLoadingComplete} />
										</Page>
									}
								/>
								<Route
									path="cart"
									element={
										<Page>
											<Cart />
										</Page>
									}
								/>
								<Route
									path="profile"
									element={
										<Page>
											<Profile onLoadingComplete={handleHomeLoadingComplete} />
										</Page>
									}
								/>
								<Route
									path="game"
									element={
										<Page>
											<Game />
										</Page>
									}
								/>
								<Route index element={<Navigate to="/home" replace />} />
							</Route>
							<Route
								path="/block"
								element={
									<Page>
										<BlockPage onLoadingComplete={handleHomeLoadingComplete} />
									</Page>
								}
							/>
							<Route path="*" element={<Navigate to="/home" replace />} />
						</Routes>
					)}

					{globalLoading && <Load />}
				</ItemProvider>
			</FavsProvider>
		</AuthProvider>
	);
}

export default App;
